/** Defines primary SSO providers (not org partners)  */
const SocialSSOProviders = ['google', 'facebook', 'linkedin'];

module.exports = {
  SocialSSOProviders,
};
